import { GET_TILE_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TILE_TYPES_SUCCESS: {
      const tileTypes = action.payload;

      if (!tileTypes){
        return [...state];
      }

      return [
        ...state,
        ...tileTypes
      ]
    }
    default:
      return state;
  }
}
